import React from 'react';

import ResolveButton from '../models/buttons/Resolve';

const QualityEventStatusManager = (status) => {
  const { collabType } = localStorage;
  // let grnFeatures = useSelector((state) => {
  //   return state.pcmp.common.accessControl.featuresAccess.grnFeatures;
  // });

  if (collabType === 'Pharma Co') {
    switch (status) {
      case 1:
        return <ResolveButton status={status} />;
      case 2:
        return <ResolveButton status={status} />;
      case 5:
        return <ResolveButton status={status} />;

      default:
        return null;
    }
  } else {
    switch (status) {
      case 1:
        return <ResolveButton status={status} />;
      case 2:
        return <ResolveButton status={status} />;
      case 5:
        return <ResolveButton status={status} />;

      default:
        return null;
    }
  }
};

export default QualityEventStatusManager;
